import $ from 'jquery';
import { send } from './form';

export const activateWebstoreForm = () => {
    var $form1 = $('#activate-webstore-form-1'),
        $form2 = $('#activate-webstore-form-2'),
        accessCodeFieldName = 'input[name=StoreCreateCode]';

    $form1.addClass('card--form--active');
    $form2.slideDown();

    // Copy field value
    $form2.find(accessCodeFieldName).val($form1.find(accessCodeFieldName).val());
};
export const deactivateWebstoreForm = () => {
    var $form1 = $('#activate-webstore-form-1'),
        $form2 = $('#activate-webstore-form-2');

    $form1.removeClass('card--form--active');
    $form2.removeClass('card--form--active');
    $form2.slideUp();
};
export const handleResponse = (response) => {
    if (response.status) {
        activateWebstoreForm();
    }
    else {
        deactivateWebstoreForm();
    }
};
export const binds = () => {
    // -------------------
    // BINDS
    // -------------------
    $('body').on('click', '[data-activate-webstore]', function(event) {
        event.preventDefault();
        send($(this), function(response) {
            handleResponse(response);
        }, function(response) {
            handleResponse(response);
        });
    });
    // ---------------- send form
    $('[data-cancel-activate-webstore-form]').on('click', function() {
        deactivateWebstoreForm();
    });
};
